// src/components/button-group/button-group.styles.ts
import { css } from "lit";
var button_group_styles_default = css`
  :host {
    display: inline-block;
  }

  .button-group {
    display: flex;
    flex-wrap: nowrap;
  }
`;

export {
  button_group_styles_default
};
